import { businessWasteRecyclingPickUpDataFr } from "constants-lib/seo/businessWasteRecyclingPickUpData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getBusinessWasteRecyclingPickUpFr = () => {
  const data = businessWasteRecyclingPickUpDataFr.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addBusinessWasteRecyclingPickUp = () => {
  if (
    window.location.href.includes(
      `/ca/fr/business/business-waste-recycling-pickup`,
    ) &&
    document.getElementById(`businessWasteRecyclingPickUpJSONLD`) === null
  ) {
    const script = BusinessWasteRecyclingPickUpJSONLDFr()
    addJSONLDToHead(script, `businessWasteRecyclingPickUpJSONLD`)
  } else {
    removeElement(`businessWasteRecyclingPickUpJSONLD`)
  }
}

const BusinessWasteRecyclingPickUpJSONLDFr = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getBusinessWasteRecyclingPickUpFr(),
  }
  return FaqBagsterTemplate
}
